import React from "react"
import { Redirect } from "react-router-dom"

//Management
import ChartHistory from "../pages/Management/ChartHistory"
import TradeHistory from "../pages/Management/TradeHistory"
import AllbaroProcess from "../pages/Management/AllbaroProcess"
import CollectHistory from "../pages/Management/CollectHistory"
import CollectHistory_v2 from "../pages/Management/CollectHistory_v2"
import CollectHistoryWrite from "../pages/Management/CollectHistoryWrite"
import ExchangePlatform from "../pages/Management/ExchangePlatform"
import SellDetailScreen from "../pages/Management/SellDetailScreen"
import BuyDetailScreen from "../pages/Management/BuyDetailScreen"
import BuyRequestWrite from "../pages/Management/BuyRequestWrite"
// import WearingHistory from "../pages/Management/WearingHistory"
import WearingHistory from "../pages/Management/WearingHistory_v2"
import BusinessList from "../pages/Management/BusinessList"
import DisposeHistory from "pages/Management/DisposeHistory"
import DisposeHistory_v2 from "pages/Management/DisposeHistory_v2"
import DisposeScreen from "pages/Management/DisposeScreen"
// import ProcessHistory from "pages/Management/ProcessHistory"
import ProcessHistory from "pages/Management/ProcessHistory_v2"
import CompanyTotalList from "pages/Management/CompanyTotalList"
import CorrespondentManagement from "pages/Management/CorrespondentManagement"
import CorrespondentWrite from "pages/Management/CorrespondentWrite"
import CorrespondentEdit from "pages/Management/CorrespondentEdit"
import CollectSchedule from "pages/Management/CollectSchedule"
import SMSShippingManagement from "pages/Management/SMSShippingManagement"
import EmailShippingManagement from "pages/Management/EmailShippingManagement"
import WorkplaceManagement from "pages/Management/WorkplaceManagement"
import TreatmentManagement from "pages/Management/TreatmentManagement"
import CollectionAreaManagement from "pages/Management/CollectionAreaManagement"
import TemplateManagement from "pages/Management/TemplateManagement"

// Bill
import EmitterBill from "../pages/Bill/EmitterBill"
import EmitterBillAll from "../pages/Bill/EmitterBillAll"
import CollectionBill from "../pages/Bill/CollectionBill"
import SettlementDetails from "../pages/Bill/SettlementDetails"
import ReportList from "../pages/Bill/ReportList"
// import payment_prepare from "../pages/Bill/PaymentPrepare"
import ReportTotalList from "../pages/Bill/ReportTotalList"
import SettlementManagement from "pages/Bill/SettlementManagement"
import SettlementManagement_v2 from "pages/Bill/SettlementManagement_v2"
import SettlementManagementDetail from "pages/Bill/SettlementManagementDetail"
import SettlementManagementDetail_v2 from "pages/Bill/SettlementManagementDetail_v2"
import InvoicingManagement from "pages/Bill/InvoicingManagement"
import InvoicingManagementDetail from "pages/Bill/InvoicingManagementDetail"
import TreatmentSettlementManagement from "pages/Bill/TreatmentSettlementManagement"

// TMS
import TMS from "../pages/TMS/TMS"
import TMS_v2 from "../pages/TMS/TMS_v2"
import TMS_test from "../pages/TMS/TMS_test"

// My Weaver
import ProfileScreen from "../pages/MyWeaver/ProfileScreen"
import ContractManagementScreen from "../pages/MyWeaver/ContractManagementScreen"
import ContractManagementScreen_v2 from "../pages/MyWeaver/ContractManagementScreen_v2"
import OutsourcingContractManagementScreen from "../pages/MyWeaver/OutsourcingContractManagementScreen"
import ServiceCenterScreen from "../pages/MyWeaver/ServiceCenterScreen"
import BusinessListScreen from "../pages/MyWeaver/BusinessListScreen"
import BusinessManagementScreen from "../pages/MyWeaver/BusinessManagementScreen"
import AllbaroManagementScreen from "../pages/MyWeaver/AllbaroManagementScreen"
import ReportManagementScreen from "../pages/MyWeaver/ReportManagementScreen"
import PlatformProductScreen from "../pages/MyWeaver/PlatformProductScreen"
import MyProductScreen from "../pages/MyWeaver/MyProductScreen"
import SellRequestWrite from "../pages/MyWeaver/SellRequestWrite"
import SellRequestUpdate from "../pages/MyWeaver/SellRequestUpdate"
import BusinessListManagementScreen from "../pages/MyWeaver/BusinessListManagementScreen"
import DriverManagementScreen from "../pages/MyWeaver/DriverManagementScreen"
import WaverBarManagementScreen from "../pages/MyWeaver/WaverBarManagementScreen"
import WasteBinManagementScreen from "../pages/MyWeaver/WasteBinManagementScreen"
import CarNumberManagementScreen from "../pages/MyWeaver/CarNumberManagementScreen"
import BusinessCompanyTotalList from "../pages/MyWeaver/BusinessCompanyTotalList"
import WithdrawlUser from "pages/MyWeaver/WithdrawlUser"
import DataRoom from "pages/MyWeaver/DataRoom"
import NoticeWrite from "pages/MyWeaver/NoticeWrite"
import DataRoomDetail from "pages/MyWeaver/DataRoomDetail"
import NoticeUpdate from "pages/MyWeaver/NoticeUpdate"
import Notice from "pages/MyWeaver/Notice"
import NoticeDetail from "pages/MyWeaver/NoticeDetail"

// Write Screen
import ContractWrite from "../pages/MyWeaver/ContractWrite"
import ContractWrite_v2 from "../pages/MyWeaver/ContractWrite_v2"
import OutsourcingContractWrite from "../pages/MyWeaver/OutsourcingContractWrite"
import OutsourcingContractWrite_v2 from "../pages/MyWeaver/OutsourcingContractWrite_v2"

// Detail Screen
import ContractManagementDetailScreen from "../pages/MyWeaver/ContractManagementDetailScreen"
import ContractManagementDetailScreen_v2 from "../pages/MyWeaver/ContractManagementDetailScreen_v2"
import OutsourcingContractManagementDetailScreen from "../pages/MyWeaver/OutsourcingContractManagementDetailScreen"
import OutsourcingContractManagementDetailScreen_v2 from "../pages/MyWeaver/OutsourcingContractManagementDetailScreen_v2"

// Authentication related pages
import Main from "../pages/Main/Main"
import KakaoMap from "../pages/KakaoMap/KakaoMap"
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Terms from "../pages/Authentication/Terms"
import serviceAgree from "pages/Authentication/ServiceAgree"
import RegisterStep1 from "../pages/Authentication/RegisterStep1/RegisterStep1"
import RegisterStep2 from "../pages/Authentication/RegisterStep2/RegisterStep2"
import RegisterFinish from "../pages/Authentication/RegisterStep3/RegisterFinish"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import SelectType from "../pages/Authentication/SelectType"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import Dashboard_v2 from "../pages/Dashboard/index_v2"

const userRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/dashboard_v2", component: Dashboard_v2 },

  //calendar
  // { path: "/calendar", component: Calendar },

  //profile
  // { path: "/profile", component: UserProfile },

  //Management
  { path: "/chart-history", component: ChartHistory },
  { path: "/trade-history", component: TradeHistory },
  { path: "/allbaro-process", component: AllbaroProcess },
  // { path: "/collect-history", component: CollectHistory },
  { path: "/collect-history", component: CollectHistory_v2 },
  { path: "/collect-history-write", component: CollectHistoryWrite },
  { path: "/exchange-platform", component: ExchangePlatform },
  { path: "/sell-detail-screen", component: SellDetailScreen },
  { path: "/buy-detail-screen", component: BuyDetailScreen },
  { path: "/buy-request-write", component: BuyRequestWrite },
  { path: "/wearing-history", component: WearingHistory },
  { path: "/business-list", component: BusinessList },
  { path: "/process-history", component: ProcessHistory },
  // { path: "/dispose-history", component: DisposeHistory },
  { path: "/dispose-history", component: DisposeHistory_v2 },
  { path: "/dispose-screen", component: DisposeScreen },
  // { path: "/company-total-list", component: CompanyTotalList },
  { path: "/company-total-list", component: BusinessList },
  { path: "/correspondent-management", component: CorrespondentManagement },
  { path: "/correspondent-write", component: CorrespondentWrite },
  { path: "/correspondent-edit", component: CorrespondentEdit },
  { path: "/collect-schedule", component: CollectSchedule },
  { path: "/sms-shipping-management", component: SMSShippingManagement },
  { path: "/email-shipping-management", component: EmailShippingManagement },
  { path: "/workplace-management", component: WorkplaceManagement },
  { path: "/treatment-management", component: TreatmentManagement },
  { path: "/collection-area-management", component: CollectionAreaManagement },
  { path: "/template-management", component: TemplateManagement },
  
  //Bill
  { path: "/emitter-bill", component: EmitterBill },
  { path: "/emitter-bill-all", component: EmitterBillAll },
  { path: "/collection-bill", component: CollectionBill },
  { path: "/settlement-details", component: SettlementDetails },
  // { path: "/payment_prepare", component: payment_prepare },
  { path: "/report-list", component: ReportList },
  { path: "/report-total-list", component: ReportTotalList },
  // { path: "/settlement-management", component: SettlementManagement },
  { path: "/settlement-management", component: SettlementManagement_v2 },
  // { path: "/settlement-management-detail", component: SettlementManagementDetail },
  { path: "/settlement-management-detail", component: SettlementManagementDetail_v2 },
  { path: "/invoicing-management", component: InvoicingManagement },
  { path: "/invoicing-management-detail", component: InvoicingManagementDetail },
  { path: "/treatment-settlement-management", component: TreatmentSettlementManagement },

  // TMS
  // { path: "/TMS", component: TMS },
  { path: "/TMS", component: TMS_v2 },
  { path: "/TMS_test", component: TMS_test },
  
  //My Weaver
  { path: "/profile-screen", component: ProfileScreen }, 
  // { path: "/contract-management-screen", component: ContractManagementScreen }, 
  { path: "/contract-management-screen", component: ContractManagementScreen_v2 }, 
  { path: "/outsourcing-contract-management-screen", component: OutsourcingContractManagementScreen }, 
  // { path: "/Uncontracted", component: Uncontracted }, 
  { path: "/service-center-screen", component: ServiceCenterScreen }, 
  { path: "/business-list-screen", component: BusinessListScreen }, 
  { path: "/business-management-screen", component: BusinessManagementScreen }, 
  { path: "/allbaro-management-screen", component: AllbaroManagementScreen }, 
  { path: "/report-management-screen", component: ReportManagementScreen }, 
  { path: "/platform-product-screen", component: PlatformProductScreen }, 
  { path: "/my-product-screen", component: MyProductScreen }, 
  { path: "/sell-request-write", component: SellRequestWrite },
  { path: "/sell-request-update", component: SellRequestUpdate },
  { path: "/business-management-list-screen", component: BusinessListManagementScreen },
  { path: "/driver-management-screen", component: DriverManagementScreen },
  { path: "/waver-bar-management-screen", component: WaverBarManagementScreen },
  { path: "/waste-bin-management-screen", component: WasteBinManagementScreen },
  { path: "/car-number-management-screen", component: CarNumberManagementScreen },
  { path: "/business-company-total-list", component: BusinessCompanyTotalList },
  { path: "/withdrawl-user", component: WithdrawlUser },
  { path: "/data-room", component: DataRoom },
  { path: "/data-room-detail/:id", component: DataRoomDetail },
  { path: "/notice", component: Notice },
  { path: "/notice-write", component: NoticeWrite },
  { path: "/notice-detail/:id", component: NoticeDetail },
  { path: "/notice-update/:id", component: NoticeUpdate },

  // Write Screen
  // { path: "/contract-management-screen-write", component: ContractWrite }, 
  { path: "/contract-management-screen-write", component: ContractWrite_v2 },
  { path: "/outsourcing-contract-management-screen-write", component: OutsourcingContractWrite_v2 }, 

  // Detail Screen
  // { path: "/contract-management-screen-detail", component: ContractManagementDetailScreen },
  { path: "/contract-management-screen-detail", component: ContractManagementDetailScreen_v2 },
  // { path: "/outsourcing-contract-management-screen-detail", component: OutsourcingContractManagementDetailScreen },
  { path: "/outsourcing-contract-management-screen-detail", component: OutsourcingContractManagementDetailScreen_v2 },

  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/main" /> },
]

const authRoutes = [
  { path: "/main", component: Main },
  { path: "/kakao-map", component: KakaoMap },
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/terms", component: Terms },
  { path: "/service-agree", component: serviceAgree },
  { path: "/register-step1", component: RegisterStep1 },
  { path: "/register-step2", component: RegisterStep2 },
  { path: "/register-finish", component: RegisterFinish },
  { path: "/select-type", component: SelectType },
]

export { userRoutes, authRoutes }
